module.exports = __webpack_public_path__ + "bg-pricing--20d5f626.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/pricing/bg-pricing.png
// module id = 17
// module chunks = 0